import {
  DefaultLocale,
  SupportedCountry,
  SupportedLanguage,
  SupportedLocaleCode,
} from '../enums'
import { isCountry, isLanguage } from './locale-utils'

export const getCountryFromLocaleCode = (
  locale: SupportedLocaleCode,
): SupportedCountry => {
  const splitLocale = locale.split('-')
  const country =
    splitLocale.length > 1
      ? splitLocale[1]
      : getCountryFromLocaleCode(DefaultLocale)

  return isCountry(splitLocale[1])
    ? (country as SupportedCountry)
    : getCountryFromLocaleCode(DefaultLocale)
}

export const getLanguageFromLocaleCode = (
  locale: SupportedLocaleCode,
): SupportedLanguage => {
  const language = locale.split('-')[0].toLowerCase()

  return isLanguage(language)
    ? (language as SupportedLanguage)
    : getLanguageFromLocaleCode(DefaultLocale)
}
